//3rd party
import React from 'react';

//material UI
import {
  Paper,
  Typography,
  ListSubheader,
  Divider,
  SvgIcon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  root: {
    //position: 'absolute',
    top: theme.spacing(1),
    left: 10,
    maxHeight: '85%',
    overflow: 'hidden'
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center'
  },
  subheaderContainer: {
    backgroundColor: '#FFF',
    paddingRight: 3,
    zIndex: 0,
    paddingLeft: 8
  },
  subheader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 28,
  },
  list: {
    width: '100%',
    paddingBottom: 0
  },
  listItem: {
    padding: '2px 4px'
  },
  listItemIcon: {
    marginRight: 0
  },
  listItemText: {
    paddingRight: 8,
    paddingLeft: 4
  },
  switch: {
    marginRight: -4
  }
});

function MapLegend(props) {
  const {
    classes,
    types,
  } = props;

  // const allVisible = types.every(
  //   type => type.visible === true
  // );

  if (types && types[0]) {
    return (
      <Paper className={classes.root}>
        <List
          className={classes.list}
          dense
          subheader={
            <ListSubheader className={classes.subheaderContainer}>
              <div className={classes.subheader}>
                <Typography variant="subtitle2">Legend</Typography>
              </div>
            </ListSubheader>
          }
        >
          <Divider />
          {types.map((type, index) => {
            return (
              <React.Fragment key={type.type}>
                <ListItem
                  className={classes.listItem}
                  key={type.type}
                >
                  <ListItemIcon className={classes.listItemIcon}>
                    <SvgIcon
                      style={{
                        color: type.color,
                        stroke: '#000',
                        strokeWidth: 1
                      }}
                    >
                      <circle cx="12" cy="12" r="6" 
                      //stroke="black" stroke-width="3" fill="red" 
                      />
                    </SvgIcon>
                  </ListItemIcon>
                  <ListItemText primary={type.type} className={classes.listItemText}/>
                </ListItem>
              </React.Fragment>
            );
          })}
        </List>
      </Paper>
    );
  }
  return <div />;
}

export default withStyles(styles)(MapLegend);